export default "__VITE_ASSET__e0749e17__"